import { render } from "./EditSalesPage.vue?vue&type=template&id=4add17dd&scoped=true&ts=true"
import script from "./EditSalesPage.vue?vue&type=script&lang=ts"
export * from "./EditSalesPage.vue?vue&type=script&lang=ts"

import "./EditSalesPage.vue?vue&type=style&index=0&id=4add17dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4add17dd"]])

export default __exports__